import { Grid, Paper } from '@material-ui/core'
import { Fragment } from 'react'
import { InstantRentStepProps } from '../InstantRentApplicationStepper'
import InstantRentForm from '../InstantRentForm'

const InstantRentSteps = ({
  currentStep,
  // apartment,
  classes,
  saveInstantRent,
  doStepBack,
  beforeLogin,
  isMobile
}: InstantRentStepProps) => {
  return (
    <Fragment>
      <Grid item sm={12} md={12}>
        <Paper className={classes.formPaper}>
          <InstantRentForm
            classes={classes}
            saveInstantRentForm={saveInstantRent}
            currentStep={currentStep}
            doStepBack={doStepBack}
            beforeLogin={beforeLogin}
            isMobile={isMobile}
          />
        </Paper>
      </Grid>
    </Fragment>
  )
}

export default InstantRentSteps
